import { h, resolveComponent } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout'
import store from '@/store'
import api from '@/api'
import { ElMessage } from 'element-plus'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: DefaultLayout,
    redirect: '/registration',
    children: [
      {
        path: '/registration',
        name: '報名資料',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/registration/add',
        children: [
          {
            path: '/registration/add',
            name: '報名資料填寫',
            component: () => import('@/views/registration/add.vue'),
          },
          {
            path: '/registration/check',
            name: '報名資料檢視',
            component: () => import('@/views/registration/check.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/pages',
    redirect: '/pages/login',
    name: 'Pages',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      },
    },
    children: [
      // {
      //   path: '404',
      //   name: 'Page404',
      //   component: () => import('@/views/pages/Page404'),
      // },
      // {
      //   path: '500',
      //   name: 'Page500',
      //   component: () => import('@/views/pages/Page500'),
      // },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/pages/Login'),
      },
      // {
      //   path: 'register',
      //   name: 'Register',
      //   component: () => import('@/views/pages/Register'),
      // },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/registration',
  },
]

const router = createRouter({
  // HTML5 Hash 模式 -> createWebHashHistory()
  // history: createWebHashHistory(process.env.BASE_URL),
  // HTML5 (History API) 模式 -> createWebHistory()
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

router.beforeEach(async (to, from) => {
  const isLoginValid = await store.dispatch('checkLoginValid')
  if (isLoginValid) {
    if (to.path === '/pages/login') {
      // 防止從網址列輸入
      if (from.path === '/') return '/registration'
      // 阻止內部router.push()
      return false
    }
    if (to.path.startsWith('/registration')) {
      const registrationFormRes =
        await api.RegistrationForm.getRegistrationForm({
          registeredEmail: store.state.registeredEmail,
          applyDepartment: store.state.applyDepartment,
        })
      if (registrationFormRes.status !== 200) {
        ElMessage({
          message: '發生錯誤,請聯絡行政人員',
          type: 'error',
        })
        store.dispatch('logout')
        return '/pages/login'
      }
      store.commit('updateRegistrationForm', {
        value: registrationFormRes.data,
      })
      if (
        to.path === '/registration/add' &&
        registrationFormRes.data.entryForm.examStatus &&
        registrationFormRes.data.entryForm.examStatus !== 'temp'
      ) {
        return '/registration/check'
      }
      if (
        to.path === '/registration/check' &&
        (registrationFormRes.data.entryForm.examStatus === 'temp' ||
          !registrationFormRes.data.entryForm.examStatus)
      ) {
        return '/registration/add'
      }
    }
  } else {
    if (to.path !== '/pages/login') {
      return '/pages/login'
    }
  }
})

export default router
